import script from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CRadioGroup.vue?vue&type=style&index=0&id=6cd28f91&lang=scss&scoped=true"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd28f91"]])

export default __exports__